import React from 'react';
import { Box, List, ListItemButton, ListItemText, Collapse, Typography, ListItemIcon } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useHistory, useLocation } from 'react-router-dom';

const DocSidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const [openOrders, setOpenOrders] = React.useState(true);

  const handleNavigate = (path) => {
    history.push(path);
  };

  const handleClickOrders = () => {
    setOpenOrders(!openOrders);
  };
  
  const openApiReference = () => {
    window.open('https://dev.api.dataportal.kaleideo.co/docs', '_blank');
  };

  return (
    <Box sx={{ width: '300px', bgcolor: 'background.paper', borderRight: '1px solid #e0e0e0', height: '100vh', overflowY: 'auto', pt: 2 }}>
      <ListItemButton onClick={() => handleNavigate('/documentation')}>
        <ListItemText primary="Documentation Home" primaryTypographyProps={{ fontWeight: 600, color: '#1976d2', fontSize: '18px' }} />
      </ListItemButton>

      <List component="nav">
        {/* <ListItemButton selected={location.pathname === '/documentation/authentication'} onClick={() => handleNavigate('/documentation/authentication')}>
          <ListItemText primary="Authentication" />
        </ListItemButton> */}
        <ListItemButton selected={location.pathname === '/documentation/explore'} onClick={() => handleNavigate('/documentation/explore')}>
          <ListItemText primary="Getting Started" />
        </ListItemButton>
        <ListItemButton selected={location.pathname === '/documentation/catalog-imagery'} onClick={() => handleNavigate('/documentation/catalog-imagery')}>
          <ListItemText primary="Catalog Imagery" />
        </ListItemButton>
        <ListItemButton selected={location.pathname === '/documentation/task-an-image'} onClick={() => handleNavigate('/documentation/task-an-image')}>
          <ListItemText primary="Task an Image" />
        </ListItemButton>
        
        <ListItemButton selected={location.pathname === '/documentation/order-management'} onClick={() => handleNavigate('/documentation/order-management')}>
          <ListItemText primary="Order and Data Management" />
        </ListItemButton>

        {/* <ListItemButton onClick={openApiReference}>
          <ListItemText primary="API Reference" />
          <ListItemIcon>
            <OpenInNewIcon fontSize="small" />
          </ListItemIcon>
        </ListItemButton> */}
      </List>
    </Box>
  );
};

export default DocSidebar;